import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import { t } from "i18next";
import icon from "../../assests/images/step1-icon.svg";
import i18n from "../../i18n";
import clockCutted from '../../assests/images/Coin_Mascot_Cutted.svg'
import { Android, Apple } from "@mui/icons-material";
import { translation_en } from "../../translations/translation_en";
import { translation_hi } from "../../translations/translation_hi";

function Instruction({
  questData,
  sethHasReadInstruction,
}: {
  questData: any;
  sethHasReadInstruction: React.Dispatch<React.SetStateAction<boolean>>;
}) {

  function translate(obj: any, path: string) {
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
}

// ✅ Choose translation based on saved language
const lang = localStorage.getItem("LANGUAGELOCALEKEY") || "en_IN";
const translations = lang.startsWith("hi") ? translation_hi : translation_en;

// ✅ Define t() function that mimics react-i18next’s syntax
const t = (key: string, vars?: Record<string, any>) => {
  let text = translate(translations, key) || key;
  if (vars) {
    Object.entries(vars).forEach(([k, v]) => {
      text = text.replace(`{{${k}}}`, String(v));
    });
  }
  return text;
};
const buildImageUrl = (path: string | null | undefined) => {
  if (!path) return null;

  // Already full URL → use directly
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  // Otherwise prefix base URL
  return `${process.env.REACT_APP_BASE_URL_image}${path}`;
};
  const [haveClicked, setHaveClicked] = useState(false)
  const tasks =
    questData?.data?.subtasks?.map((subtask: any, index: number) => ({
      subtitle: subtask?.question,
      question_id: subtask?.question_id,
      sampleImage: buildImageUrl(subtask?.sample_picture),
      task_id: subtask?.task_id,
      reward:

        questData?.data.bonus_point > 0
          ? `${t("earn_pnts.points_earn_diwali", {
            points: subtask.points || 0,
            bonus: questData?.data.bonus_point || 0,
          })}`
          : `${t("earn_pnts.points_earn", { points: subtask.points || 0 })}`,
      // reward: `${t('earn_pnts.points_earn', { points: subtask.points || 0 })}`,
      steps:
        subtask?.hint?.steps?.map((step: any) => ({
          step: `${t("taskdetaitls.dot_code_scanning.step_label")}`,
          description: step.step_text,
          icon: buildImageUrl(step?.step_icon),
        })) || [],
      sample_picture: subtask?.hint?.sample_image,
      // takeAPic: subtask?.options[0].option_value
    })) || [];


  return (
    <Box sx={{ paddingBottom: "90px" }}>
      <Box
        sx={{
          borderRadius: "16px",
          border: "1px solid rgba(250, 212, 102, 0.00)",
          background:
            "linear-gradient(110deg, rgba(255, 248, 187, 0.00) 38.52%, rgba(220, 220, 106, 0.32) 100%), #FFF",
          margin: "15px 10px 0 15px",
        }}>
        <Box
          sx={{
            paddingLeft: "16px",
            textAlign: "left",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box sx={{ padding: "15px 0" }}>
            <Typography
              variant="caption1"
              sx={{
                color: "#7D7E7F",
                letterSpacing: "0.24px",
                textTransform: "uppercase",
                fontWeight: "600",
              }}
            >
              Task
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontWeight: "600", letterSpacing: "0.16px" }}
            >
              {questData?.data?.task}
            </Typography>
          </Box>
          <Box sx={{ padding: "18px 0" }}>
            <img
              width={155}
              height={55}
              crossOrigin="anonymous"
              src={clockCutted}
              alt="task banner"
            />
          </Box>
        </Box>
        {/* <Box  sx={{ padding: "5px 15px" }}>
          <Typography
            variant="body2"
            sx={{ fontWeight: "600", letterSpacing: "0.16px",textAlign:"left" }}
          >
            {i18n.language==='hi'?questData?.data?.task_desc_hi:questData?.data?.task_desc_en}
          </Typography>
      </Box> */}
      </Box>
      {tasks
        .filter((va: any, ind: any) => ind === 0)
        .map((task: any, index: any) => (
          <Box
            key={index}
            sx={{
              background: "#FFFFFF",
              borderRadius: "12px",
              margin: "10px 10px",
              textAlign: "left",
            }}
          >
            <Box
              sx={{
                padding: "12px 16px 0px 16px",
                gap: "12px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="caption1"
                sx={{ color: "#7D7E7F", fontWeight: "600", display: "block" }}
              >
                {task.steps[0].step}:
              </Typography>
              {task.steps.map((step: any, stepIndex: any) => (
                <>
                  <Box key={stepIndex}>
                    <Box
                      key={stepIndex}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <Box
                        sx={{
                          width: "100%",
                          maxWidth: "45px",
                          height: "45px",
                          // backgroundColor: "#FFEBEF",
                          // borderRadius: "50%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {/* <Icons name={step.icon} /> */}
                        {step.icon !== null ? (
                          <img
                            crossOrigin="anonymous"
                          src={step.icon || "/default-icon.png"} alt="Step Icon"
                          />
                        ) : (
                          <img
                            crossOrigin="anonymous"
                            src={`${icon}`}
                          />
                        )}
                      </Box>
                      <Box sx={{ textAlign: "left" }}>
                        <Typography
                          variant="caption1"
                          sx={{ fontWeight: "600", lineHeight: "1" }}
                        >
                          {step.description}
                        </Typography>
                      </Box>

                    </Box>
                    <Button
                      className="btn_red"
                      sx={{ backgroundColor: "#C8172F", color: "white", marginBottom: "12px", marginTop: "12px" }}
                      startIcon={<Android />}
                      href="https://play.google.com/store/apps/details?id=com.shelfwatch&hl=en_US"
                      onClick={() => setTimeout(() => {
                        setHaveClicked(true)
                      }, 2000)}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("taskdetaitls.clicklink.download1")}

                    </Button>
                    <Button
                      className="btn_red"
                      sx={{ backgroundColor: "#C8172F", color: "white" }}
                      startIcon={<Apple />}
                      href="https://apps.apple.com/us/app/shelfwatch/id1498946973"
                      target="_blank"
                      onClick={() => setTimeout(() => {
                        setHaveClicked(true)
                      }, 2000)}
                      rel="noopener noreferrer"
                    >
                      {t("taskdetaitls.clicklink.download2")}
                    </Button>
                  </Box>
                </>
              ))}

            </Box>
          </Box>
        ))}

      <Box className="foot">
        <Button
          type="submit"
          className="btn_red"
          disabled={!haveClicked}
          onClick={() => sethHasReadInstruction(true)}
        >
          {t("taskdetaitls.clicklink.next_btn")}
        </Button>
      </Box>
    </Box>
  );
}

export default Instruction;
